<template>
  <b-card>
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <alert ref="alert" />
    <b-tabs vertical>
      <b-tab title="Change password" title-link-class="nav-link-custom" active>
        <b-row class="w-50">
          <b-form @submit="onSubmit" class="w-75">
            <b-form-group label="Old password" label-for="ddown-form-email" label-class="text-left">
              <b-input-group>
                <b-form-input :type="inputTypes.oldPassword" v-model="form.oldPassword" required placeholder="Old password" size="sm"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info"
                    @mousedown="inputTypes.oldPassword = 'text'"
                    @mouseup="inputTypes.oldPassword = 'password'"
                    class="pwd-btn">
                    <b-icon-eye-slash v-if="inputTypes.oldPassword == 'password'"></b-icon-eye-slash>
                    <b-icon-eye-fill v-else></b-icon-eye-fill>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group label="New password" label-for="ddown-form-passwd" label-class="text-left">
              <b-input-group>
              <b-form-input :type="inputTypes.newPassword" v-model="form.newPassword" required placeholder="New password" size="sm"></b-form-input>
              <b-input-group-append>
                  <b-button variant="info"
                    @mousedown="inputTypes.newPassword = 'text'"
                    @mouseup="inputTypes.newPassword = 'password'"
                    class="pwd-btn">
                    <b-icon-eye-slash v-if="inputTypes.newPassword == 'password'"></b-icon-eye-slash>
                    <b-icon-eye-fill v-else></b-icon-eye-fill>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Confirm new password" label-for="ddown-form-passwd" label-class="text-left">
              <b-input-group>
                <b-form-input :type="inputTypes.confirmNewPassword" v-model="form.confirmNewPassword" required placeholder="Confirm new password" size="sm"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info"
                    @mousedown="inputTypes.confirmNewPassword = 'text'"
                    @mouseup="inputTypes.confirmNewPassword = 'password'"
                    class="pwd-btn">
                    <b-icon-eye-slash v-if="inputTypes.confirmNewPassword == 'password'"></b-icon-eye-slash>
                    <b-icon-eye-fill v-else></b-icon-eye-fill>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-button type="submit" variant="primary" size="sm" class="float-right">Change</b-button>
          </b-form>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import service from '../../services/HttpRequestService';
import formatter from '../../utilities/Formatter';
import Alert from '../Alert';
import { TRACE_ERROR } from '../../constants';

export default {
  props: {
    path: String
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      inputTypes: {
        oldPassword: 'password',
        newPassword: 'password',
        confirmNewPassword: 'password'
      },
      showSpinner: false,
      alert: {
        timestamp: 0,
        type: '',
        msg: ''
      }
    };
  },
  methods: {
    async onSubmit(evt) {
      this.showSpinner = true;
      evt.preventDefault();
      try {
        let res = await service.changePassword(
          this.form.oldPassword,
          this.form.newPassword,
          this.form.confirmNewPassword
        );
        this.$refs.alert.showAlert('success', 'Password changed');
      } catch (err) {
        await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      } finally {
        this.showSpinner = false;
        this.form = {
          oldPassword: '',
          newPassword: '',
          confirmNewPassword: ''
        };
      }
    }
  },
  components: {
    Alert
  }
};
</script>

<style lang="scss"  scoped>
.nav-tabs {
  .nav-link-custom,
  &.active {
    border-color: #dee2e6 !important;
    border-radius: 0.25rem !important;
  }
}
.pwd-btn {
  padding: 0.25rem 0.35rem;
}
</style>
